export default __webpack_public_path__ + "static/media/vector.ba0bc67d.svg";